<!--
 * @Author: houmy
 * @Date: 2023-08-29 18:44:12
 * @LastEditors: 
 * @LastEditTime: 2023-08-29 18:58:53
 * @FilePath: \zx-home\src\App.vue
 * @Description: 
 * 
-->
<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    Header,
    Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue